// src/js/main.js
import '../styles/style.css';

import { fetchProducts } from './api.js';
import { initSlider } from './slider.js';
import { initModal } from './modal.js';
import { submitDetails } from './form.js';

window.onload = async () => {
  try {
    const productsData = await fetchProducts();
    const productHTML = document.querySelector(".slider-track");

    productHTML.innerHTML = "";

    productsData.forEach(item => {
      productHTML.innerHTML += `
        <div class="product-card">
          <img src="${item.imgSrc}" alt="${item.name}">
          <h3>${item.name}</h3>
          <p>${item.description}</p>
          <p class="price">₹${item.price}</p>
        </div>
      `;
    });

    initSlider();
    initModal();

  } catch (error) {
    console.error("Failed to load products", error);
  }
};

const submit = document.querySelector("#submitSupport")
submit.addEventListener("click",submitDetails)
